module.exports = __webpack_public_path__ + "img/IMG_2024_L_Wood.33d22216.jpg";